import { ProtocolAddress } from '../../../types/protocol'
import {
  generateLevelAddress,
  generateKeyLevelAddress,
  generateSensorModeAddress,
  generateMacroAddressLevel,
} from './addressGenerators'

export const ADDRESS_LM20_RT = {
  CURRENT_CONNECT_PROTOCOL: [0x04, 0x01], // 当前使用的通信协议，0：2.4G 连接方式；1: BLE 连接方式;
  CONFIG_CURRENT: [0x0c, 0x01],
  RF_PROTOCOL_SETTING: [0x60, 0x00],
  //  哪种定义Level的Address都可以
  //  CONFIG_NAME: [ // 方式一 直接定义
  //    [0x0C, 0x09],
  //    [0x0C, 0x0d],
  //    [0x0C, 0x11],
  //    [0x0C, 0x15],
  //    [0x0C, 0x19],
  //    [0x0C, 0x1d],
  //    [0x0C, 0x21],
  //    [0x0C, 0x25],
  //  ],
  FW_VERSION_0: [0x10, 0x00], // 固件版本字节 1（ 最低字节）
  FW_VERSION_1: [0x11, 0x00], // 固件版本字节 2
  FW_VERSION_2: [0x12, 0x00], // 固件版本字节 3
  FW_VERSION_3: [0x13, 0x00], // 固件版本字节 4（ 最高字节）
  PAIRING_1: [0x20, 0x00], // 对码地址 1 的最低字节
  PAIRING_3: [0x28, 0x00], // 对码地址 2 （备份）的最低字节
  PAIRING_4: [0x30, 0x00], // 对码地址 3 （备份）的最低字节
  CONFIG_NAME: generateLevelAddress(0x03ec), // 方式二 方法生成
  //  定义鼠标EEPROM位置
  MOUSE_LEFT: generateLevelAddress(0x0000), // 左键
  MOUSE_MID: generateLevelAddress(0x0004), // 中键
  MOUSE_RIGHT: generateLevelAddress(0x0008), // 右键
  MOUSE_CPIADD: generateLevelAddress(0x000c), // DP+
  MOUSE_CPIREDUCE: generateLevelAddress(0x0010), // DPI-
  MOUSE_FORWARD: generateLevelAddress(0x0014), // 前进键
  MOUSE_BACK: generateLevelAddress(0x0018), // 后退键
  MOUSE_ROLLFORWARD: generateLevelAddress(0x0024), // 滚轮前滚
  MOUSE_ROLLBACK: generateLevelAddress(0x0028), // 滚轮后滚
  MOUSE_ROLLRIGHT: generateLevelAddress(0x002c), // 侧轮前滚
  MOUSE_ROLLLEFT: generateLevelAddress(0x0030), // 侧轮左滚
  MOUSE_BOTTOM: generateLevelAddress(0x0034), // 底部自定义键
  MOUSE_BLE: generateLevelAddress(0x0038), // 蓝牙键
  MOUSE_KEY_LIST: generateKeyLevelAddress(), // 按键列表

  MOUSE_REPORT: generateLevelAddress(0x0280), // 回报率
  MOUSE_SCAN_RATE: generateLevelAddress(0x0281), // 扫描率
  MOUSE_SLIGHT: generateLevelAddress(0x0284), // 84:静默高度  85：MOTION 86: 2.4g工作模式 87:有线工作模式
  MOUSE_MOTION: generateLevelAddress(0x0285), // 移动同步
  MOUSE_DPI_X_LIST: generateLevelAddress(0x0288), // X轴DPI数值
  MOUSE_DPI_CUR: generateLevelAddress(0x0298), // 当前DPI档位
  MOUSE_DPI_Y_LIST: generateLevelAddress(0x02c8), // Y轴DPI数值
  MOUSE_DPI_ENABLE_GEAR: generateLevelAddress(0x0296), // DPI的可用档位
  MOUSE_DPI_GEAR_LENGTH: 7, // DPI的最大档位7 常量 非地址但相关
  MOUSE_DOWNDELAY: generateLevelAddress(0x02c0), // 按下消抖延时
  MOUSE_LIFTDELAY: generateLevelAddress(0x02c1), // 抬起消抖延时
  MOUSE_SLEEPTIME: generateLevelAddress(0x02c2), // 睡眠时间
  MOUSE_LINEAR_RIPPLE: generateLevelAddress(0x02c3), // 直线修正曲线修正
  MOUSE_SENSORANGLE: generateLevelAddress(0x02c4), // 传感器角度
  MOUSE_GLASS: generateLevelAddress(0x02c5), // 玻璃过面
  MOUSE_LOWPOWER: generateLevelAddress(0x02c6), // sensor低功耗模式
  MOUSE_LIGHTMOD: generateLevelAddress(0x0299), // 99:灯光模式 9A：灯光速度 9B:灯光亮度
  MOUSE_LIGHTRGB: generateLevelAddress(0x02b8), // 鼠标灯光颜色
  MOUSE_POWERSAVE: generateLevelAddress(0x02ac), //TODO 鼠标节能模式 ? 02ac + 3 02aF
  RF_STRENGTHEN_SWITCH: generateLevelAddress(0x02d8), // rf强化开关
  LOW_POWE_WARN_SWITCH: generateLevelAddress(0x02d9), // 低电量提示开关
  LOW_DC_SWITCH: generateLevelAddress(0x02da), // DC 开/关
  MOUSE_REPORT_SENSOR_MODE: generateSensorModeAddress(0x02dc), // 传感器模式
  MACRO_PACKAGE_ADDRESS: generateMacroAddressLevel(0x00010000, 12), // 宏包地址
  MACRO_NAME_ADDRESS: generateMacroAddressLevel(0x0000fd00, 12, 0x10), // 宏包名称地址
  MACRO_PRESSURE_ADDRESS: generateMacroAddressLevel(0x00020000, 4), // 压枪宏包地址

  // ==================== RT 磁轴参数（功能定义 v1.08） ====================
  // 注：文档中的 RT 参数为配置区绝对地址（如左键 RT 开关 = 0x08E4），
  //     本处转成相对配置区基址(0x0600)的偏移交给 genrateLevelAddress 生成多配置地址。
  RT_LEFT_SWITCH: generateLevelAddress(0x02e4), //左键RT快速触发开关: 0=关; 1=开
  RT_LEFT_TRAVEL: generateLevelAddress(0x02e8), // 左键触发行程 1~10，默认5
  RT_LEFT_RT_TRAVEL: generateLevelAddress(0x02e9), // 左键RT行程 1~10，默认2
  RT_RIGHT_SWITCH: generateLevelAddress(0x02ec), //右键RT快速触发开关: 0=关; 1=开
  RT_RIGHT_TRAVEL: generateLevelAddress(0x02f0), // 右键触发行程 1~10，默认5
  RT_RIGHT_RT_TRAVEL: generateLevelAddress(0x02f1), // 右键RT行程 1~10，默认2
  RT_LEFT_VIBRATION_PRESS: generateLevelAddress(0x02f4), // 左键按下马达振动级别 0~10，0表示关闭
  RT_LEFT_VIBRATION_RELEASE: generateLevelAddress(0x02f5), // 左键释放马达振动级别 0~10，0表示关闭
  RT_VIBRATION_FEEDBACK_TYPE: generateLevelAddress(0x02f6), // 振动反馈类型: 0=机械微动; 1=光微动; 2=电磁微动，默认1
  RT_RIGHT_VIBRATION_PRESS: generateLevelAddress(0x02f8), // 右键按下马达振动级别 0~10，0表示关闭
  RT_RIGHT_VIBRATION_RELEASE: generateLevelAddress(0x02f9), // 右键释放马达振动级别 0~10，0表示关闭
  RT_LEFT_SOUND_PRESS: generateLevelAddress(0x02fc), // 左键按下Beep类型级别 0~10，0表示关闭
  RT_LEFT_SOUND_RELEASE: generateLevelAddress(0x02fd), // 左键释放Beep类型级别 0~10，0表示关闭
  RT_LEFT_SOUND_VOLUME: generateLevelAddress(0x02fe), // 左键Beep音量 1~100，0表示关闭
  RT_RIGHT_SOUND_PRESS: generateLevelAddress(0x0300), // 右键按下Beep类型级别 0~10，0表示关闭
  RT_RIGHT_SOUND_RELEASE: generateLevelAddress(0x0301), // 右键释放Beep类型级别 0~10，0表示关闭
  RT_RIGHT_SOUND_VOLUME: generateLevelAddress(0x0302), // 右键Beep音量 1~100，0表示关闭
} as const satisfies ProtocolAddress
